import { render, staticRenderFns } from "./LandownerReports.vue?vue&type=template&id=2bec6ec4"
import script from "./LandownerReports.vue?vue&type=script&lang=js"
export * from "./LandownerReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports